import React from 'react';
import { observer } from 'mobx-react-lite';
import { HomePageCarouselState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { FormHeaderWrapper, TabItemSecondary, TabsWrapperSecondary } from 'src/domains/layouts/shared/tabs/Tabs.style';

interface HomePageCarouselFilterType {
    carouselPromoState: HomePageCarouselState;
}

export const HomePageCarouselFilter = observer(({ carouselPromoState }: HomePageCarouselFilterType) => {
    const { selectFilter, tabs, homePageCarouselItemType, isEditMode, resetForm } = carouselPromoState;

    return (
        <FormHeaderWrapper>
            <TabsWrapperSecondary>
                {tabs.map(({ dataTest, type, label }, ind) => (
                    <TabItemSecondary
                        key={ind}
                        data-test={dataTest}
                        disabled={isEditMode}
                        isActive={homePageCarouselItemType === type}
                        onClick={(): void => selectFilter(type)}
                    >
                        {label}
                    </TabItemSecondary>
                ))}
            </TabsWrapperSecondary>
            {isEditMode && (
                <Button
                    onClick={resetForm}
                    size='small'
                    version='secondary'
                >
                    Back
                </Button>
            )}
        </FormHeaderWrapper>
    );
});
